import React, {useState} from 'react';

const ChatUser = ({users, setSelectedUser, selectedUser, isLoading}) => {
    const [defaultAvatar] = useState("/assets/images/chat/av-1.png");
    const formatTime = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    };
    return (
        <div>
              <div className="users-list">
                {isLoading ? (
                  <p className='text-center mt-4'>Please wait...</p>
                ):(
                  <>
                                  {users && users.map((user) => (
                  <div
                    key={user.customerId}
                    className={`user-item ${
                      selectedUser?.customerId === user.customerId
                        ? "active"
                        : ""
                    }`}
                    onClick={() => setSelectedUser(user)}
                  >
                    {/* <img
                      src={defaultAvatar}
                      alt={user.name}
                      className="user-avatar"
                    /> */}
                    <div className="user-info">
                      <h4>{user.name || user.customerId}</h4>
                      <p className="last-message">
                        {user.lastMessage?.body || ""}
                      </p>
                    </div>
                    <div className="message-meta">
                      <span className="time">
                        {user.lastMessage?.date
                          ? formatTime(user.lastMessage.date)
                          : ""}
                      </span>
                      {user.unreadCount > 0 && (
                        <span className="unread-count">{user.unreadCount}</span>
                      )}
                    </div>
                  </div>
                ))}
                  </>
                )}

              </div>
        </div>
    );
};

export default ChatUser;